/**
 *
 * Copyright 2017 sgmelearninng
 * @author sin
 * models注册入口.将models注册入口统一，防止主框架代码修改
 *
 *
 */

export const appDevModels  = require('./localDevModels').appDevModels;
//export const getAppDevModels  = require('./localDevModels').getAppDevModels;
